import * as React from 'react';
import { USERNAME, LAST_NAME, DOB, POSTCODE } from 'ts/constants/UrlParams';
import { Content } from 'ts/passwordless-login/components/pages/find-email/Interfaces';
import { findAccountForManualRegWithCaptcha } from 'ts/services/find-account/FindAccountService';
import { ROUTES } from 'ts/Routes';
import { FindEmailPage } from 'ts/passwordless-login/components/pages/find-email/FindEmailPage';
import { sendOtcAndRedirect } from './Actions';
import { History, Location } from 'history';
import { RouteComponentProps } from 'react-router-dom';
import { errorPageAction, getUserProvidedUsername } from './SharedUtils';

const nextAction = (history: History, location: Location) => async (username: string) =>
  sendOtcAndRedirect(history, username, getUserProvidedUsername(location));

const conflictAccountAction = (history: History, location: Location) => (
  lastName: string,
  dob: string,
  postcode: string,
) => {
  const username = getUserProvidedUsername(location);
  history.push({
    pathname: ROUTES.MANUAL_REG_ACCOUNT_NUMBER,
    search: `?${LAST_NAME}=${lastName}&${DOB}=${dob}&${POSTCODE}=${postcode}&${USERNAME}=${username}`,
  });
};

const findAccountAction = (lastName: string, dob: string, postcode: string) => {
  return findAccountForManualRegWithCaptcha(lastName, dob, postcode);
};

const ManualRegCustomerLookupPage: React.FC<RouteComponentProps> = ({ history, location }) => {
  const email = getUserProvidedUsername(location);
  const businessRegistrationUrl = `#${ROUTES.MANUAL_REG_FIND_BUSINESS_CUSTOMER}?email=${email}`;

  const content: Content = {
    analytics: {
      taskType: 'auth:manual-reg',
      navigation: {
        friendlyUri: 'originenergy:my-account:auth:manual-reg-verify',
      },
      errorForm: {
        formName: 'auth:manual-reg',
        errorMessage: 'auth:manual-reg:account-not-found',
        errorCode: 'account-not-found',
      },
    },
    copy: {
      headingText: 'Let’s find your account details',
      infoText: `We can’t seem to find **${email}** in our system. Don’t worry, we just need a few extra details to get you into My Account. Or, [register as a business customer](${businessRegistrationUrl}).`,
      alertBoxText:
        "We're having trouble finding you in our system. Please [get in touch](LIVECHAT), one of our agents can help you out.",
    },
  };
  return (
    <FindEmailPage
      findAccountAction={findAccountAction}
      content={content}
      history={history}
      nextAction={nextAction(history, location)}
      conflictAccountAction={conflictAccountAction(history, location)}
      errorPageAction={errorPageAction(history)}
    />
  );
};

export { ManualRegCustomerLookupPage };
